<template>
    <b-dropdown
        v-b-tooltip.hover
        variant="dark2"
        :title="$translate('skip_to')"
        :text="$translate(selectedEventName)"
        class="event-skip-amount-handler"
        :boundary="boundary"
    >
        <b-dropdown-item
            v-for="(eventName, idx) in eventNames"
            :key="eventName"
            :class="`${eventName}-dropdown-option${isDayMode ? ' day-mode' : ''}`"
            @click.stop.prevent="goToEvent(eventName)"
        >
            <template v-if="isDayMode">
                <span>{{ eventNameLabels[idx].day }}</span>
                <span>{{ eventNameLabels[idx].range }}</span>
            </template>

            <template v-else>
                {{ $translate(eventName) }}
            </template>
        </b-dropdown-item>
    </b-dropdown>
</template>

<script>
import { ALL_DAYS } from '../../../business/const'

export default {
    name: 'EventSkipAmountHandler',
    props: {
        eventNames: {
            type: Array,
            required: true
        },
        selectedEventName: {
            type: String,
            default: ''
        },
        isDayMode: {
            type: Boolean,
            default: false
        },
        // ref : https://bootstrap-vue.org/docs/components/dropdown#boundary-constraint
        boundary: {
            type: String,
            default: 'scrollParent'
        }
    },
    computed: {
        eventNameLabels() {
            return this.eventNames.map(eventName => {
                const i = parseInt(eventName.replace('day', ''))

                const range = `${ALL_DAYS[i].hours}${
                    i === ALL_DAYS.length - 1 ? 'h+' : `-${ALL_DAYS[i + 1].hours}h`
                }`
                return { day: `D${i}`, range }
            })
        }
    },
    methods: {
        goToEvent(eventName) {
            this.$emit('eventChosen', eventName)
        }
    }
}
</script>

<style lang="scss">
.day-mode {
    .dropdown-item {
        display: grid;
        grid-template-columns: 1fr 2fr;
        column-gap: 1rem;
    }
}
</style>
